import React, { useState } from "react";
import moment from "moment";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Content,
    FloatInput,
    LoadingSpinner,
    Row,
    Textarea,
} from "@webtypen/react-components";
import { Page } from "../../components/Page";
import { ApiHelper, ConfirmHelper } from "../../helpers";

export const ContractRequest = () => {
    const [hasSuccess, setHasSuccess] = useState(false);
    const [alert, setAlert] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState({
        date: "",
        customer_contract_number: "",
        number_shifts: 1,
        address_street: "",
        address_zip: "",
        address_city: "",
        guests: "",
        message: "",
    });

    const onChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    };

    const save = () => {
        const today = moment().format("YYYY-MM-DD");
        if (!data.date || data.date.trim() === "" || data.date <= today) {
            ConfirmHelper.alert("Es muss ein gültiges Datum angegeben werden!");
            return;
        }

        if (!data.number_shifts || parseInt(data.number_shifts) < 1) {
            ConfirmHelper.alert("Es muss mindestens eine Schicht angegeben werden!");
            return;
        }

        setIsSaving(true);
        setAlert(null);
        ApiHelper.request("/api/contracts/requests/create", data)
            .then((response) => {
                if (response.status === "success" && response.data && response.data._id) {
                    setHasSuccess(true);
                } else {
                    setAlert(
                        response.status === "error" && response.message && response.message.trim() !== ""
                            ? response.message
                            : "Es ist ein unerwarteter Fehler aufgetreten ..."
                    );
                }
                setIsSaving(false);
            })
            .catch((e) => {
                console.error(e);
                setAlert(
                    e && e.data && e.data.status === "error" && e.data.message && e.data.message.trim() !== ""
                        ? e.data.message
                        : "Es ist ein unerwarteter Fehler aufgetreten ..."
                );
                setIsSaving(false);
            });
    };

    return (
        <Page icon={faFileContract} title="Auftragsanfrage erstellen">
            <Content>
                {hasSuccess ? (
                    <div style={{ maxWidth: 600, margin: "auto" }}>
                        <Alert success>
                            <div>
                                <b>Auftragsanfrage erfolgreich erstellt</b>
                            </div>
                            Vielen Dank! Wir werden uns schnellstmöglich bei Ihnen melden!
                        </Alert>
                    </div>
                ) : (
                    <div style={{ maxWidth: 600, margin: "auto" }}>
                        {alert ? <Alert color={alert[0]}>{alert[1]}</Alert> : null}

                        <Card>
                            <CardHeader>Auftragsinformationen</CardHeader>
                            <CardBody>
                                <Row>
                                    <Col width={4}>
                                        <FloatInput
                                            type="date"
                                            placeholder="Datum"
                                            name="date"
                                            value={data.date}
                                            onChange={onChange}
                                            disabled={isSaving}
                                        />
                                    </Col>
                                    <Col width={8}>
                                        <FloatInput
                                            type="text"
                                            placeholder="Ihre Auftragsnummer (optional)"
                                            name="customer_contract_number"
                                            value={data.customer_contract_number}
                                            onChange={onChange}
                                            disabled={isSaving}
                                        />
                                    </Col>
                                    <Col width={12} className="mt-3">
                                        <b>Wie viele Servicekräfte / Schichten werden benötigt?</b>
                                    </Col>
                                    <Col width={4}>
                                        <FloatInput
                                            type="number"
                                            placeholder="Schichten"
                                            name="number_shifts"
                                            value={data.number_shifts}
                                            onChange={onChange}
                                            disabled={isSaving}
                                        />
                                    </Col>
                                    <Col width={12} className="mt-3">
                                        <b>Wie viele Gäste werden kommen?</b>
                                    </Col>
                                    <Col width={4}>
                                        <FloatInput
                                            type="text"
                                            placeholder="Gäste"
                                            name="guests"
                                            value={data.guests}
                                            onChange={onChange}
                                            disabled={isSaving}
                                        />
                                    </Col>
                                    <Col width={12} className="mt-3">
                                        <b>Adresse?</b>
                                    </Col>
                                    <Col width={12}>
                                        <FloatInput
                                            type="text"
                                            placeholder="Straße + Hausnummer"
                                            name="address_street"
                                            value={data.address_street}
                                            onChange={onChange}
                                            disabled={isSaving}
                                            className="mb-2"
                                        />
                                    </Col>
                                    <Col width={4}>
                                        <FloatInput
                                            type="text"
                                            placeholder="PLZ"
                                            name="address_zip"
                                            value={data.address_zip}
                                            onChange={onChange}
                                            disabled={isSaving}
                                            className="mb-2"
                                        />
                                    </Col>
                                    <Col width={8}>
                                        <FloatInput
                                            type="text"
                                            placeholder="Stadt"
                                            name="address_city"
                                            value={data.address_city}
                                            onChange={onChange}
                                            disabled={isSaving}
                                            className="mb-2"
                                        />
                                    </Col>
                                    <Col width={12} className="mt-3">
                                        <b>Zusatz Informationen</b>
                                    </Col>
                                    <Col width={12}>
                                        <Textarea
                                            style={{ height: 150 }}
                                            name="message"
                                            value={data.message}
                                            onChange={onChange}
                                            disabled={isSaving}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        <div className="text-right mt-2">
                            <Button disabled={isSaving} onClick={save} primary>
                                {isSaving ? <LoadingSpinner /> : "Absenden"}
                            </Button>
                        </div>
                    </div>
                )}
            </Content>
        </Page>
    );
};
